<!-- ===== HEADER ===== -->
<div class="po-confirm__header">
  <div class="po-confirm__header-left">
    <div class="po-confirm__icon-circle">
      <mat-icon>error_outline</mat-icon>
    </div>
    <div class="po-confirm__header-text">
      @if (!isEditMode) {
        <h3 class="po-confirm__title">
          Confirm {{orderingGroups.length}} Purchase Order{{orderingGroups.length > 1 ? 's' : ''}}
        </h3>
      }
      @if (isEditMode) {
        <h3 class="po-confirm__title">
          @if (vendorGroupList && vendorGroupList.length === 1) {
            <span>
              Update Purchase Order
            </span>
          }
          @if (vendorGroupList && vendorGroupList.length > 1) {
            <span>
              Update/Create {{vendorGroupList?.length}} Purchase Orders
            </span>
          }
        </h3>
      }
      <p class="po-confirm__subtitle">Review the details below before confirming</p>
    </div>
  </div>
  <button mat-icon-button class="po-confirm__close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- ===== SUMMARY HEADER ===== -->
<div class="po-confirm__summary-header">
  <div class="col-md-1"></div>
  <div class="col-md-2">PO NO</div>
  <div class="col-md-3">VENDOR(S)</div>
  <div class="col-md-2">ITEMS</div>
  <div class="col-md-2 text-nowrap">TOTAL AMOUNT</div>
  <div class="col-md-2 ps-5">ACTION</div>
</div>

<!-- ===== VENDOR LIST ===== -->
<!-- Only the vendors something is actually being ordered from. A vendor whose lines are all
     covered by warehouse stock has no purchase order to confirm; their materials are listed
     under "reserved from warehouse stock" below. -->
<div class="po-confirm__vendor-list">
  @for (item of orderingGroups; track item) {
    <div class="po-confirm__vendor-row">
      <mat-expansion-panel [disabled]="true" [expanded]="item?.isExpand" class="po-confirm__panel">
        <mat-expansion-panel-header [ngStyle]="{'background-color': item.color}" class="po-confirm__panel-header">
          <mat-panel-title class="w-100">
            <div class="row w-100 align-items-center">
              <div class="col-md-3 d-flex align-items-center">
                <button mat-icon-button (click)="togglePanel(item)" class="po-confirm__expand-btn"
                  [attr.aria-label]="item?.isExpand ? 'Close panel' : 'Open panel'">
                  <mat-icon>{{ item?.isExpand ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
                <!-- PO number display -->
                @if (isEditMode) {
                  <span class="ms-2">
                    @if (item.isExistingVendor) {
                      <span class="fw-bold">{{item.po_number}}</span>
                    }
                    @if (!item.isExistingVendor) {
                      <span class="text-muted">Pending</span>
                    }
                  </span>
                }
                @if (!isEditMode) {
                  <span class="ms-2">
                    @if (item.po_number) {
                      <span>{{item.po_number}}</span>
                    }
                    @if (!item.po_number) {
                      <span class="text-muted">Pending</span>
                    }
                  </span>
                }
              </div>
              <div class="col-md-3 text-center ps-4 d-flex align-items-center">
                @if (item?.is_discount) {
                  <img src="../../../../assets/img/general_icons/dicount-tag-icon.svg" alt=""
                    class="me-2" />
                }
                {{item?.name}}
              </div>
              <div class="col-md-2 text-center">
                {{orderableLines(item.materialList).length}}
              </div>
              <div class="col-md-2 text-center ps-5 fw-bold">
                {{ getGroupTotal(item) | currency:'USD' }}
              </div>
              @if (item?.po_id) {
                <div class="col-md-2 text-center ps-5">
                  <i class="fa fa-eye ps-5" (click)="viewPurchseOrde(item)"></i>
                </div>
              }
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div style="overflow: auto;" class="mt-4">
          <div class="table-responsive">
            <table class="table table-bordered table-purchase-order" style="width:100%">
              <thead>
                <tr>
                  <th scope="col">MATERIAL</th>
                  <th scope="col">ORDER QTY</th>
                  <th scope="col">UNIT COST</th>
                  <th scope="col">CONTRACT COST</th>
                </tr>
              </thead>
              <tbody>
                <!-- Only what this purchase order will carry, at the quantity and price it will
                     carry it at. The table used to list every ticked line at its full need and
                     catalog price, so a line wholly covered by warehouse stock appeared as if it
                     were being bought and the rows did not add up to the total below them. -->
                @for (mat of orderableLines(item.materialList); track mat) {
                  <tr class="table-content">
                    <td class="pt-4">{{mat?.product_name}}</td>
                    <td class="pt-4">{{lineOrderQty(mat)}}</td>
                    <td class="pt-4">{{poLineUnitCost(mat) | currency:'USD'}}</td>
                    <td class="pt-4">{{lineOrderTotal(mat) | currency:'USD'}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          @if (!item?.is_free_shipping) {
            <div class="po-confirm__shipping-row">
              <span class="po-confirm__shipping-label">
                <mat-icon class="po-confirm__truck-icon">local_shipping</mat-icon>
                Shipping Charges
              </span>
              <span class="po-confirm__shipping-value">{{(item?.fee_ship ? item?.fee_ship : 0) | currency}}</span>
            </div>
          }
          <div class="col-12 p-0">
            <div class="d-flex align-items-center justify-content-between bg-orange-">
              <div class="info-label p-2 font-bold">TOTAL</div>
              <div class="info-label p-2 font-bold">{{ getGroupTotal(item) | currency }}
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  }
</div>

<!-- What the buyer ticked that the warehouse settles instead, so nothing they chose disappears
     from the confirmation without a word. Listed once, outside the orders, because these lines
     are on none of them. -->
@if (reservedOnlyLines.length) {
  <div class="po-confirm__stock-list">
    @for (mat of reservedOnlyLines; track mat) {
      <div class="po-confirm__stock-row">
        <mat-icon class="po-confirm__stock-icon">inventory_2</mat-icon>
        <span>
          <b>{{mat?.product_name}}</b> — all {{lineReservedQty(mat)}} reserved from warehouse
          stock, so it is not on this order.
        </span>
      </div>
    }
  </div>
}

<!-- ===== FOOTER ===== -->
@if (!isPONumberGenerated) {
  <div class="po-confirm__footer">
    <!-- Summary row -->
    <div class="po-confirm__footer-row">
      <div class="po-confirm__footer-left">
        <span><strong>{{orderingGroups.length}}</strong> PO(s)</span>
        <span><strong>{{getTotalItems()}}</strong> items</span>
      </div>
      <div class="po-confirm__footer-right">
        <div class="po-confirm__total-label">Total Value</div>
        <div class="po-confirm__total-value">{{getTotalAmount() | currency:'USD'}}</div>
      </div>
    </div>
    <!-- Loading indicator -->
    @if (isProcessing) {
      <div class="po-confirm__loading">
        <div class="po-confirm__spinner"></div>
        <p>Processing...</p>
      </div>
    }
    <!-- Buttons row -->
    <div class="po-confirm__footer-buttons">
      <button type="button" class="btn cancel-btn po-confirm__btn--flex" (click)="close()" [disabled]="isProcessing">Cancel</button>
      <button type="button" class="btn add-purchase-order-button po-confirm__confirm-btn po-confirm__btn--flex" (click)="confirm()" [disabled]="isProcessing">
        <mat-icon class="po-confirm__check-icon">check_circle</mat-icon>
        Confirm
      </button>
    </div>
  </div>
}
